const adjustSdkIntialization = () => {
  if (typeof window !== 'undefined') {
    const AdjustSdk = require('@adjustcom/adjust-web-sdk');
    AdjustSdk.initSdk({
      appToken: process.env.NEXT_PUBLIC_ADJUST_API_TOKEN,
      environment: process.env.NEXT_PUBLIC_ADJUST_ENV,
    });
    return AdjustSdk;
  }
};

export const sendAdjustEvent = (token) => {
  const adjustEvent = adjustSdkIntialization();
  adjustEvent.trackEvent({
    eventToken: token,
  });
};

export const sendAdjustEventWithParameters = (token, data) => {
  const adjustEvent = adjustSdkIntialization();
  adjustEvent.addGlobalCallbackParameters([{ key: token, value: data }]);
  adjustEvent.trackEvent({
    eventToken: token,
    callbackParams: [{ key: token, value: data }],
  });
};

export const sendAdjustAddToCartEvent = (token, data) => {
  const adjustEvent = adjustSdkIntialization();
  adjustEvent.trackEvent({
    eventToken: token,
    callbackParams: [
      { key: 'contentType', value: data.product_type },
      { key: 'contentId', value: data.product_sku },
      { key: 'currency', value: data.currency },
      { key: 'valueToSum', value: data.value.toString() },
    ],
    partnerParams: [
      { key: 'contentType', value: data.product_type },
      { key: 'contentId', value: data.product_sku },
      { key: 'currency', value: data.currency },
      { key: 'valueToSum', value: data.value },
    ],
  });
};

export const sendAdjustIntiateChekoutPharmacyEvent = (token, data) => {
  const adjustEvent = adjustSdkIntialization();
  adjustEvent.trackEvent({
    eventToken: token,
    callbackParams: [
      { key: 'currency', value: data.currency },
      { key: 'valueToSum', value: data.value.toString() },
    ],
    partnerParams: [
      { key: 'currency', value: data.currency },
      { key: 'valueToSum', value: data.value.toString() },
    ],
  });
};

export const sendAdjustIntiateChekout = (token, data) => {
  const adjustEvent = adjustSdkIntialization();
  adjustEvent.trackEvent({
    eventToken: token,
    callbackParams: [{ key: 'Speciality', value: data }],
    partnerParams: [{ key: 'Speciality', value: data }],
  });
};

export const sendAdjustAddedPaymentInfoPharmacyEvent = (token, currency, valueToSum) => {
  const adjustEvent = adjustSdkIntialization();
  adjustEvent.trackEvent({
    eventToken: token,
    callbackParams: [
      { key: 'currency', value: currency },
      { key: 'valueToSum', value: valueToSum?.toString() },
    ],
    partnerParams: [
      { key: 'currency', value: currency },
      { key: 'valueToSum', value: valueToSum?.toString() },
    ],
  });
};

export const sendAdjustAddPaymentInfoEvent = (token, docName, speciality, bookingMode) => {
  const adjustEvent = adjustSdkIntialization();
  adjustEvent.trackEvent({
    eventToken: token,
    callbackParams: [
      { key: 'Speciality', value: speciality },
      { key: 'Doctor Name', value: docName },
      { key: 'Booking mode', value: bookingMode },
    ],
    partnerParams: [
      { key: 'Speciality', value: speciality },
      { key: 'Doctor Name', value: docName },
      { key: 'Booking mode', value: bookingMode },
    ],
  });
};

export const sendAdjustPurchasePharmacyEvent = (token, id, currency, totalAmount) => {
  const adjustEvent = adjustSdkIntialization();
  adjustEvent.trackEvent({
    eventToken: token,
    callbackParams: [
      { key: 'currency', value: currency },
      { key: 'valueToSum', value: totalAmount?.toString() },
      { key: 'contentType', value: 'Epharmacy' },
      { key: 'contentId', value: id },
    ],
    partnerParams: [
      { key: 'currency', value: currency },
      { key: 'valueToSum', value: totalAmount?.toString() },
      { key: 'contentType', value: 'Epharmacy' },
      { key: 'contentId', value: id },
    ],
    revenue: totalAmount,
  });
};

export const sendAdjustViewContentPharmacyEvent = (token, id) => {
  const adjustEvent = adjustSdkIntialization();
  adjustEvent.trackEvent({
    eventToken: token,
    callbackParams: [
      { key: 'contentType', value: 'Epharmacy' },
      { key: 'contentId', value: id },
    ],
    partnerParams: [
      { key: 'contentType', value: 'Epharmacy' },
      { key: 'contentId', value: id },
    ],
  });
};

export const sendAdjustConfirmAppointmentEvent = (token, speciality, doctorName, bookingMode, currency, valueToSum) => {
  const adjustEvent = adjustSdkIntialization();
  adjustEvent.trackEvent({
    eventToken: token,
    callbackParams: [
      { key: 'Specialty', value: speciality },
      { key: 'Booking mode', value: bookingMode },
      { key: 'Value to Sum', value: valueToSum },
      { key: 'Doctor Name', value: doctorName },
      { key: 'currency', value: currency },
    ],
    partnerParams: [
      { key: 'Specialty', value: speciality },
      { key: 'Booking mode', value: bookingMode },
      { key: 'Value to Sum', value: valueToSum },
      { key: 'Doctor Name', value: doctorName },
      { key: 'currency', value: currency },
    ],
  });
};

export const sendAdjustInitiateCheckoutEvent = (token, data) => {
  const adjustEvent = adjustSdkIntialization();
  adjustEvent.trackEvent({
    eventToken: token,
    callbackParams: [{ key: 'Speciality', value: data }],
  });
};

export const sendAdjustPurchaseConsultDoctor = (token, data) => {
  const adjustEvent = adjustSdkIntialization();
  adjustEvent.trackEvent({
    eventToken: token,
    callbackParams: [
      { key: 'contentType', value: 'Teleconsultation' },
      { key: 'contentId', value: data?.doctorId },
      { key: 'Doctor Name', value: data?.doctorName },
      { key: 'Speciality', value: data?.doctorSpecialty },
      { key: 'Facility Type', value: data?.facilityType },
      { key: 'Facility Name', value: data?.facilityName },
      { key: 'currency', value: 'AED' },
      { key: 'Value to Sum', value: data?.paymentAmount },
    ],
    partnerParams: [
      { key: 'contentType', value: 'Teleconsultation' },
      { key: 'contentId', value: data?.doctorId },
      { key: 'Doctor Name', value: data?.doctorName },
      { key: 'Speciality', value: data?.doctorSpecialty },
      { key: 'Facility Type', value: data?.facilityType },
      { key: 'Facility Name', value: data?.facilityName },
      { key: 'currency', value: 'AED' },
      { key: 'Value to Sum', value: data?.paymentAmount },
    ],
  });
};
